import {
	AUTH_SUCCESS,
	FETCH_TOKEN_INFO_SUCCESS,
	LOGOUT,
	LOGOUT_FROM_ONE_DEVICES_SUCCESS,
	SET_ID,
} from "app/actionTypes";
import {
	CLEAR_OAUTHORIZATION_CODE,
	OAUTH_SUCCESS,
	SAVE_OAUTHORIZATION_CODE,
} from "app/pages/Auth/OAuth/oAuthActionTypes";
import { SET_CAN_LOGIN_AT, SET_SESSION_BIID, SET_USER_BIID } from "app/pages/Auth/AuthActionTypes";
import { decodeJWTToken } from "app/utils/utils";
import { AUTH_OPERATOR } from "app/pages/Operator/OperatorActionCreators";

const initialState = {
	oAuthorizationCode: undefined,
	tokenInfos: [],
	uuid: undefined,
	sessionBiidExpirationDate: undefined,
	sessionBiid: undefined,
	userBiid: undefined,
	operatorAuthToken: undefined, // token de l'operator utilisé pour envoyer un devis
	operatorEmail: undefined, // email de l'operator si celui s'est connecté
	canLoginAt: undefined,
};

export default function authReducer(auth = initialState, action) {
	switch (action.type) {
		case SET_SESSION_BIID: {
			return {
				...auth,
				sessionBiid: action.sessionBiid,
				sessionBiidExpirationDate: action.sessionBiidExpirationDate,
			};
		}
		case SET_USER_BIID: {
			return {
				...auth,
				userBiid: action.userBiid,
			};
		}
		case AUTH_OPERATOR: {
			return {
				...auth,
				operatorEmail: decodeJWTToken(action.token)?.operator,
				operatorAuthToken: action.agentToken,
				uuid: action.uuid,
			};
		}
		case AUTH_SUCCESS: {
			return Object.assign({}, auth, {
				uuid: action.uuid,
				operatorEmail: decodeJWTToken(action.token)?.operator,
			});
		}
		case OAUTH_SUCCESS: {
			return {
				...auth,
				oAuthorizationCode: undefined,
			};
		}
		case CLEAR_OAUTHORIZATION_CODE: {
			return {
				...auth,
				oAuthorizationCode: undefined,
			};
		}
		case SAVE_OAUTHORIZATION_CODE: {
			return {
				...auth,
				oAuthorizationCode: action.code,
			};
		}
		case LOGOUT_FROM_ONE_DEVICES_SUCCESS:
		case FETCH_TOKEN_INFO_SUCCESS: {
			return {
				...auth,
				tokenInfos: action.tokenInfos,
			};
		}
		case LOGOUT:
			return {
				...initialState,
				sessionBiidExpirationDate: auth.sessionBiidExpirationDate,
				sessionBiid: auth.sessionBiid,
				userBiid: auth.userBiid,
			};
		case SET_ID:
			return Object.assign({}, auth, {
				uuid: action.uuid,
			});
		case SET_CAN_LOGIN_AT:
			return {
				...auth,
				canLoginAt: action.canLoginAt,
			};
		default:
			return auth;
	}
}
